import { makeStyles } from 'tss-react/mui';

import { CHAINS_PAGE_WIDTH } from 'modules/chains/constants';

const name = 'ChainPage';

export const useChainPageStyles = makeStyles({ name })(() => ({
  content: {
    display: 'flex',
    flexDirection: 'column',

    maxWidth: CHAINS_PAGE_WIDTH,
  },
}));
